module.exports = __webpack_public_path__ + "media/assets/google_classroom_logo_large-c5963551769dc108de932bb82005555e.svg";